<template>
<div class="themen__navigation" :class="{ 'collapse': !show }">
    <a @click.prevent="toggle" class="contentnav__close"><i class="fal" :class="{ 'fa-bars': !show, 'fa-times': show }"></i></a>

    <p class="h5">{{ title }}</p>
    <div class="themen__nav-hider">
    <div class="themen__nav-hidden" ref="overflowNav">
    <div class="themen__nav-overflow" id="menuspy">
    <ul>
        <li class="contentnav__item" v-for="item in items" v-bind:key="item.href">
          <a :href="item.href" :class="{ 'active': item.active }" :ref="'nav' + item.id" @click.prevent="scrollToElement">
            {{ item.text }}
          </a>
        </li>
    </ul>
    </div>
    </div>
    </div>
</div>
</template>

<script>
export default {
  name: "MenuSpy",

  data() {
    return {
      show: true,
      items: [],
      title: "Themen auf dieser Seite:",
    }
  },

  mounted() {
    this.loadItems();
    window.addEventListener("scroll", this.scroll);
    window.addEventListener("resize", this.loadItems);
    if (window.innerWidth < 1800) {
      this.show = false;
    }
  },

  methods: {
    loadItems() {
      const list = document.querySelector(".themen");
      this.items = [];
      list.querySelectorAll("section").forEach((elm) => {
        const id = elm.getAttribute("id");
        if (id) {
          const item = {
            text: elm.querySelector("h2").innerText,
            href: "#" + id,
            elm: elm,
            active: false,
            id: id
          };

          this.items.push(item);
        }
      });
    },

    track() {
    },

    scroll() {
      let scrollTop = (window.pageYOffset || document.documentElement.scrollTop) - 150;
      var activeItem = null;

      this.items.forEach((item) => {
        if (item.active) {
          item.active = false;
        }

        if (scrollTop > item.elm.offsetTop) {
          activeItem = item;
        }
      });

      if (activeItem) {
        activeItem.active = true;

        window.clearTimeout(this.isScrolling);
        var inst = this;
        this.isScrolling = setTimeout(function() {
          if (!inst.$refs['nav' + activeItem.id]) {
            return;
          }
          inst.$refs.overflowNav.scrollTop = inst.$refs['nav' + activeItem.id][0].offsetTop - 150;
        }, 100);
      }
    },

    scrollToElement(e) {
      const elmId = e.target.getAttribute("href");
      const elm = document.querySelector(elmId);

      if (!elm) {
        return;
      }

      window.scrollTo({
        top: elm.offsetTop + 250,
        behavior: 'smooth'
      });
    },

    toggle() {
      this.show = !this.show;
    }
  }
}
</script>
